import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {NgxDropzoneChangeEvent} from "ngx-dropzone-next";

@Component({
    selector: 'app-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss'],
    standalone: false
})
export class UploadComponent  {
  @Input() allowOnlyPdf = false;
  @Input() multiple = true;
  @Input() maxFiles: number;
  @Input() accept = '*';
  @Input() maxFileSize: number;
  @Input() expandable = false;

  files: File[] = [];

  @Output()
  onFileChange: EventEmitter<NgxDropzoneChangeEvent> = new EventEmitter<NgxDropzoneChangeEvent>();

  constructor() {}

  onSelect(event: NgxDropzoneChangeEvent): void {
    if(event?.addedFiles) {
      this.files.push(...event.addedFiles);
      if (!this.multiple && this.files.length > 1) {
        this.replaceFile();
      } else if (this.maxFiles && this.files.length > this.maxFiles) {
        this.removeFile();
      }

      this.onFileChange.emit(event);
    }
  }

  onRemove(file: File): void {
    this.files.splice(this.files.indexOf(file), 1);

    this.onFileChange.emit();
  }

  replaceFile(): void {
    this.files.splice(0, 1);
  }

  removeFile(): void {
    this.files.splice(this.files.length - 1, 1);
  }
}
